/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
import React, { useEffect, useRef } from 'react';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import World from './map';
import common from '../../index.module.scss';
import s from './index.module.scss';

const timeoutValues = [300, 80, 150, 450, 300, 200, 50, 1, 300, 100];

function Map(props) {
	const { T } = useT();
	const description = useRef(null);

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'map',
			stepStatus: true
		});

		let number = 125671;
		const numbersNode = description.current.querySelector('span');

		setInterval(() => {
			setTimeout(() => {
				numbersNode.innerHTML = (++number).toLocaleString();
			}, timeoutValues[Math.floor(Math.random() * 10)]);
		}, 200);
	}, []);

	return (
		<div className={common.step}>
			<h1 className={s.title}>{T('map_title')}</h1>
			<World data={props} />
			<div ref={description} className={s.description} dangerouslySetInnerHTML={{ __html: T('map_description') }} />
		</div>
	);
}

export default Map;
